module.exports = __webpack_public_path__ + "img/fc-lokomotiv-moscow.14663800.png";